module.exports = __webpack_public_path__ + "img/chatBg1.8d07a09.8d07a091.png";